import React, { useEffect, useState } from "react";
import TemplateQuestions from "../../components/Edit-Template/Template-Questions";
import TemplatePreview from "../../components/Edit-Template/Template-Preview";
import { NavLink } from "react-router-dom";
import { setDocument } from "../../redux/reducers/document-reducer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Template, FormData } from "../../types/Templates";

export const getUpdatedTemplateContent = (templateAnswers: FormData, previewTemplate: Template) => {
  let content = previewTemplate.content;

  previewTemplate?.questions?.forEach((question, index) => {
    const answer = templateAnswers[`answer${index + 1}`]
      ? `<strong>${templateAnswers[`answer${index + 1}`].value}</strong>`
      : `<span className="text-red-400">_____</span>`;
    const placeholderRegex = new RegExp(question?.placeholderId, 'g');
    content = content.replace(placeholderRegex, answer);
  });
  
  return content;
};

const EditTemplate = () => {
  const dispatch = useDispatch();
  const selectedTemplate = useSelector((state: RootState) => state.selectedTemplate) as Template;
  
  // Create a properly typed template object with type assertion
  const template = selectedTemplate || {
    id: "",
    name: "",
    title: "",
    content: "",
    category: {
      name: "",
      sub_categories: {
        result: [] as string[]
      }
    },
    sub_category: {
      name: ""
    },
    questions: [] as { placeholderId: string; question: string }[]
  } as Template;

  const pdfRef = React.useRef<HTMLDivElement | null>(null);

  // Initialize formData with proper typing
  const [formData, setFormData] = useState<FormData>(() => {
    if (!template.questions) return {};
    return template.questions.reduce((acc: FormData, _, index: number) => {
      acc[`answer${index + 1}`] = { value: "" };
      return acc;
    }, {});
  });

  const [isNull, setIsNull] = useState(true);

  useEffect(() => {
    if (formData) {
      setIsNull(Object.values(formData).some((value) => value.value === ""));
    }
  }, [formData]);

  return (
    <div className="flex flex-col items-start w-full pt-32 px-4 md:px-12 py-12">
      {!template?.questions ? (
        <div className="flex flex-col items-center w-full">
          <h2>No Template Selected.</h2>
          <NavLink
            to={"/templates"}
            className="mt-4 px-4 py-2 bg-gray-600 text-white font-semibold rounded-md"
          >
            Select Template
          </NavLink>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 w-full">
            <TemplateQuestions
              template={template}
              setFormData={setFormData}
              formData={formData}
            />
            <TemplatePreview
              pdfRef={pdfRef}
              previewTemplate={template}
              templateAnswers={formData}
            />
          </div>
          <div className="flex flex-row items-center">
            <NavLink
              to={"/templates/lawyer"}
              className={`mt-4 px-4 py-2 ${
                isNull ? "bg-gray-600" : "bg-blue-600"
              } text-white font-semibold rounded-md
              ${!isNull && "hover:bg-blue-700"}`}
              onClick={(e) => {
                if (isNull) {
                  e.preventDefault();
                } else {
                  const content = getUpdatedTemplateContent(formData, template);
                  dispatch(setDocument({ content, template }));
                }
              }}
            >
              Next
            </NavLink>
          </div>
        </>
      )}
    </div>
  );
};

export default EditTemplate;
